import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import { AuthenticationService } from 'app/auth/service';
import {NotificationService} from "../service/notification.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private _router: Router,
                private _authenticationService: AuthenticationService,
                private _notificationService: NotificationService,) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                console.error('HTTP Error Intercepted:', err);
                if (err.status === 401) {
                    // Attempt to refresh the token
                    return this._authenticationService.refreshToken().pipe(
                        switchMap(() => {
                            // Retry the original request with the new token
                            const token = this._authenticationService.currentTokenValue;
                            request = request.clone({
                                setHeaders: { Authorization: `Bearer ${token}` }
                            });
                            return next.handle(request);
                        }),
                        catchError(refreshError => {
                            // Refresh failed, redirect to login
                            this._authenticationService.logout();
                            this._router.navigate(['/account/login']);
                            return throwError(refreshError);
                        })
                    );
                }
                if (err.status === 403) {
                    const customError = err.error?.error;

                    if (customError) {
                        switch (customError) {
                            case 'ModuleNotAuthorized': // SCENARIO 1: Access Level
                                this._router.navigate(['/miscellaneous/not-authorized'], {
                                    queryParams: { reason: 'Module' }
                                });
                                break;

                            case 'SessionConcurrencyViolation': // SCENARIO 2: Single Active Session
                                this._notificationService.customizedWarning('Your session expired because you logged in from another device.');
                                this._authenticationService.logout();
                                this._router.navigate(['/account/login'], {
                                    queryParams: { sessionExpired: true }
                                });
                                break;

                            case 'SessionExpired': // SCENARIO 3: Token Expiration
                                this._notificationService.customizedWarning('Your login session has expired. Please log in again.');
                                this._authenticationService.logout();
                                this._router.navigate(['/account/login'], {
                                    queryParams: { sessionExpired: true }
                                });
                                break;

                            default:
                                // Fallback for any other 403 error
                                this._router.navigate(['/miscellaneous/not-authorized']);
                                break;
                        }
                    } else {
                        this._router.navigate(['/miscellaneous/not-authorized']);
                    }
                    return throwError(() => err);
                }
                const error = err.error?.message || err.statusText;
                return throwError(() => error);
            })
        );
    }
}